export default class ListIssuesByPropertyIdError extends Error {

}